import { castToBoolean } from '../util';

class Language {
  constructor(data) {
    data = data || {};
    this.name = data.name || null;
    this.name_english = data.name_english || null;
    this.id = data.id || null;
    this.locale = data.locale || null;
    this.active = castToBoolean(data.active, true);
    this.system_default = castToBoolean(data.system_default, false);
  }

  get isSystemDefault() {
    return this.system_default;
  }
}

export default Language;
